import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/integrations/mobly/services/products'

const findOne = (sku, organization) => AxiosClient.get(
  `${resource}/${sku}`, { headers: { organization } }
)

export {
  findOne
}
